import { useState, useEffect } from 'react'
import { fetchFeatureFlags } from './useApi'

export const useFeatureFlags = () => {
    const [flags, setFlags] = useState({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        const loadFeatureFlags = async () => {
            try {
                setLoading(true)
                setError(null)
                const featureFlags = await fetchFeatureFlags()
                setFlags(featureFlags)
            } catch (err) {
                console.error('Error loading feature flags:', err)
                setError(err.message)
                // No default flags - if not available, features are disabled
                setFlags({})
            } finally {
                setLoading(false)
            }
        }

        loadFeatureFlags()
    }, [])

    // Check if all flags are true to determine if experimental is enabled
    const experimentalEnabled =
        Object.keys(flags).length > 0 &&
        Object.values(flags).every(value => value === true)

    return { flags, loading, error, experimentalEnabled }
}

export default useFeatureFlags
